import React from 'react';
import { Link, useLocation } from 'react-router-dom';

/** Prefill the page the visitor is on, so the team knows what they were looking at. */
function whatsappUrl(pathname) {
  const page = pathname === '/' ? 'your website' : `your ${pathname.replace(/^\//, '').split('/')[0].replace(/-/g, ' ')} page`;
  return `https://wa.me/919587773274?text=${encodeURIComponent(`Hi Apnaaapan, I was on ${page} and want to talk about growing my brand.`)}`;
}

/**
 * Sticky contact bar for phones: call, WhatsApp and book a call are always one tap away.
 * Hidden on the booking page itself and on md+ screens (the header CTA covers those).
 */
const MobileCtaBar = () => {
  const { pathname } = useLocation();
  if (pathname === '/book-call' || pathname === '/thank-you') return null;

  const itemClass =
    'flex-1 min-h-[52px] flex flex-col items-center justify-center gap-0.5 text-[11px] font-semibold rounded-xl transition-transform active:scale-95 focus:outline-none focus-visible:ring-2 focus-visible:ring-apn-orange';

  return (
    <>
      {/* Spacer so the fixed bar never covers the end of the page */}
      <div className="h-[68px] md:hidden bg-[#0E0F14]" aria-hidden="true" />
      <nav
        aria-label="Quick contact"
        className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-apn-surface border-t border-apn-line shadow-[0_-8px_24px_-8px_rgba(0,0,0,0.18)] flex gap-1.5 px-2 pt-1.5"
        style={{ paddingBottom: 'max(6px, env(safe-area-inset-bottom))' }}
      >
        <a href="tel:+919587773274" data-cta="mobile-bar-call" className={`${itemClass} text-apn-ink`}>
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
          </svg>
          Call
        </a>
        <a href={whatsappUrl(pathname)} data-cta="mobile-bar-whatsapp" className={`${itemClass} bg-[#25D366] text-[#0B2E17]`}>
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488" />
          </svg>
          WhatsApp
        </a>
        <Link
          to="/book-call"
          data-cta="mobile-bar-book"
          className={`${itemClass} text-white bg-gradient-to-r from-orange-500 to-yellow-400`}
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
          Book a Call
        </Link>
      </nav>
    </>
  );
};

export default MobileCtaBar;
